import CCPage from './DibbsRFQWizard';

export default CCPage;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/index.jsx